window.groomSlotByDayConfig = {
    "dateOverrides": {
        "2026-11-05": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 2
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-11-06": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 2
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-11-07": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 2
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-11-25": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 1
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 1
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-11-26": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 1
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 1
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-11-27": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-11-28": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-12-05": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-12-06": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-12-07": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-12-08": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-12-21": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-12-22": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-12-23": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-12-24": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-12-28": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 2
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-12-29": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 2
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-12-30": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 2
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2026-12-31": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-02": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-03": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-04": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-05": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-06": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-07": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-08": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-09": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 0
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 0
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-11": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 1
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 1
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-12": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 1
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 1
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-13": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 1
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 1
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-14": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 1
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 1
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-15": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 1
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 1
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        },
        "2027-01-16": {
            "timeRanges": [
                {
                    "start": "11:45",
                    "end": "13:30",
                    "capacity": 1
                },
                {
                    "start": "16:30",
                    "end": "18:30",
                    "capacity": 1
                },
                {
                    "start": "18:30",
                    "end": "19:15",
                    "capacity": 0
                }
            ]
        }
    }
};
